<!-- 首页 -->
<template>
  <div>
    <my-header></my-header>
    <div class="postion">
      <keep-alive>
        <rotation></rotation>
      </keep-alive>

      <search></search>
    </div>

    <div class="home_link">
      <router-link tag="a" class="home_link1" to="/companyInfo/blocVI?FileClassify=1&RootId=4&InteralDirId=12">
        <img src="../../assets/img/home_link1.png">
        <h2>集团VI</h2>
        <h4>LOGO使用规范、应用规范等</h4>
      </router-link>
      <router-link tag="a" class="home_link2" to="/creativePhoto/parkPhoto?FileClassify=1&RootId=6&InteralDirId=17">
        <img src="../../assets/img/home_link2.png">
        <h2>乐园照片</h2>
        <h4>热门项目、最新活动……</h4>
      </router-link>
      <router-link tag="a" class="home_link3" to="/companyInfo/cprPhoto?FileClassify=1&RootId=4&InteralDirId=15">
        <img src="../../assets/img/home_link3.png">
        <h2>版权素材</h2>
        <h4>人物肖像授权、创意图片</h4>
      </router-link>
      <router-link tag="a" class="home_link4" to="/companyInfo/amimationSource?FileClassify=1&RootId=4&InteralDirId=14&ThirdLevelCatelogId=255">
        <img src="../../assets/img/home_link4.png">
        <h2>熊出没素材</h2>
        <h4>熊出没电影、动画片系列</h4>
      </router-link>
      <router-link tag="a" class="home_link5" to="/companyInfo/cprPhoto?FileClassify=1&RootId=4&InteralDirId=16">
        <img src="../../assets/img/home_link5.png">
        <h2>版权字体</h2>
        <h4>公司版权字体、免费商用字体</h4>
      </router-link>
    </div>

    <ul class="navigation">
      <li><span :class="{actived:activedIndex==-1}" @click="getData(-1,'CreateTime')">最新发布</span></li>
      <li><span :class="{actived:activedIndex==-2}" @click="getData(-2,'Hot')">创意精选</span></li>
      <li v-for="(item,index) in ClassifyLabel " :key="index">
        <span :class="{actived:activedIndex==index}" @click="getData(index,item.Id)">{{item.Name}}</span>
      </li>

    </ul>

    <div class="clear"></div>
    <div v-if="flag">
      <waterFall :apiType="3" :isPick="true" :fileList="ListData"></waterFall>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import home_link1 from "../../assets/img/home_link1.png";
import home_link2 from "../../assets/img/home_link2.png";
import home_link3 from "../../assets/img/home_link3.png";
import rotation from "../common/rotation";
import classify from "../common/classify";
import waterFall from "../common/waterfall";
import search from "../common/search";
import { GetHomeLabels } from "../../assets/js/modules/indexApi.js"

export default {
  data() {
    return {
      activedIndex: "-1",
      ClassifyLabel: [],//首页推荐系统便签
      flag: true,//瀑布流重新加载
      ListData: {
        IsHomePage: true,
        LabelIds: [],
        Sorting: "Hot",
      }
    }
  },
  methods: {
    // 查是否存在该数组
    arrayCheck(array, obj) {
      var thatIndex = -1;
      array.forEach(function (item, index) {
        if (obj == item) {
          thatIndex = index;
        }
      });
      return thatIndex;
    },
    getData(index, id) {
      if (this.activedIndex != index) {
        this.activedIndex = index;
        if (index < 0) {
          this.ListData.Sorting = id;
          this.ListData.LabelIds = [];
        } else {
          this.ListData.LabelIds[0] = id;
          this.ListData.Sorting = ""
        };
        this.flag = false;
        this.$nextTick(function () {
          this.flag = true;
        });
      }



    },
    //  获取首页分类列表系统标签
    getHomeLabels1() {
      let data = {
        SkipCount: 0,
        MaxResultCount: 5
      }
      GetHomeLabels(data).then(
        res => {
          if (res.data.Success) {
            this.ClassifyLabel = res.data.Data
          }
        },
        error => {

        }
      )
    }
  },
  mounted() {
    this.getHomeLabels1();
  },
  beforeCreate() {
    window.location.href = 'https://media.fangte.com/'
  },
  components: {
    rotation,
    classify,
    waterFall,
    search
  },

};
</script>
<style scoped>
.home_link {
  width: 1280px;
  height: 170px;
  margin: 35px auto 50px;
  display: flex;
  justify-content: space-between;
}
.home_link a {
  position: relative;
  display: block;
  text-align: center;
  background-color: #fff;
  border-radius: 10px;
  width: 250px;
  box-shadow: 3px 3px 8px rgba(205, 215, 221, 0.2);
  padding: 30px 0 15px;
  transition: 0.5s;
  -webkit-transition: 0.5s;
}
.home_link a:hover {
  margin-top: -5px;
  box-shadow: 3px 3px 8px rgba(146, 160, 169, 0.2);
}
.home_link a img {
  display: inline-block;
  margin: 0 auto;
}
.home_link a h2 {
  font-size: 20px;
  color: #333;
  margin: 10px 0 5px;
}
.home_link a h4 {
  font-size: 14px;
  color: #999;
}
.postion {
  position: relative;
}
.navigation {
  width: 1100px;
  display: flex;
  display: -webkit-flex;
  margin: 0 auto;
}
.navigation li {
  flex: 1;
  -webkit-box-flex: 1;
  text-align: center;
  font-size: 18px;
  color: #333333;
}
.navigation li span {
  border-bottom: 4px solid transparent;
  display: inline-block;
  line-height: 1.5;
  padding: 0 10px;
  cursor: pointer;
}
.navigation li span.actived {
  border-bottom: 4px solid #6aa9ff;
}
.navigation li span:hover {
  border-bottom: 4px solid #6aa9ff;
}
</style>



// WEBPACK FOOTER //
// src/components/index/home.vue